import React from "react";
import styled from "styled-components";
import { lightThemeColors } from "../../assets/style/colors";
import { motion } from "framer-motion";

const ResultsCard = ({ title, description, titleStyle }) => {
  return (
    <Container>
      <TextWrapper>
        <Title style={titleStyle}>{title}</Title>
        <Description>{description}</Description>
      </TextWrapper>
    </Container>
  );
};

export default ResultsCard;

const Container = styled.div`
  overflow: hidden;
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 20px;
  padding: 20px;
  border-radius: 10px;
  background: ${lightThemeColors.lightColor};
  height: 100%;
  max-width: 400px;
`;
const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  overflow: hidden;
`;

const Title = styled.h3`
  color: ${lightThemeColors.darkColor};
  font-weight: 800;
  font-size: 28px;
  line-height: 34px;
`;

const Description = styled.p`
  color: ${lightThemeColors.darkColor};
  font-weight: 700;
  font-size: 22px;
  line-height: 28px;
  white-space: pre-line;
`;
